import { createRoutesFromElements, Route } from 'react-router'

import { LoggedOut, LoggingOut } from 'authentication/Logout'
import NotFoundPage from 'infrastructure/NotFoundPage'
import { PrivateRoutes } from 'infrastructure/shared/components'
import LoadSitemodel from 'site/Load'
import EditTools from 'site/EditTools/EditTools'
import TanstackRouterProvider from 'routing/TanstackRouterProvider'
import { AnyRouter } from '@tanstack/react-router'

type CreateReactRouterRoutesProps = {
  tanstackRouter: AnyRouter
}

export const createReactRouterRoutes = ({
  tanstackRouter
}: CreateReactRouterRoutesProps) =>
  createRoutesFromElements(
    <>
      <Route element={<PrivateRoutes />}>
        {/* No support for optional parameters in v6 */}
        {/* https://reactrouter.com/docs/en/v6/faq#what-happened-to-regexp-routes-paths */}
        <Route index element={<LoadSitemodel isIndex />} />
        <Route path=':sitemodelUuid' element={<LoadSitemodel />} />
        <Route path=':sitemodelUuid/edit' element={<EditTools />} />
        <Route path='masterdata/:objectclassUuid' element={<LoadSitemodel />} />
        <Route
          path='poc-ssr/*'
          element={<TanstackRouterProvider router={tanstackRouter} />}
        />
        <Route path='*' element={<NotFoundPage />} />
      </Route>

      <Route path='/logout' element={<LoggingOut />} />
      <Route path='/logged-out' element={<LoggedOut />} />
    </>
  )
